import { render, staticRenderFns } from "./InfractionTypeForm.vue?vue&type=template&id=e61d9c34"
import script from "./InfractionTypeForm.vue?vue&type=script&lang=js"
export * from "./InfractionTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports